import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "fotter"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "wrap_header" }, [
      _createElementVNode("div", { class: "menubar" }, [
        _createElementVNode("ul")
      ])
    ], -1)),
    ($props.isLoggedIn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "wrap_header" }, [
            _createElementVNode("p", { class: "coppyi" }, "© Copyright 2024 - Bệnh viện Y học cổ truyền thành phố Đà Nẵng- Designed by voontv@gmail.com")
          ], -1)
        ])))
      : _createCommentVNode("", true)
  ], 64))
}